module.exports = __webpack_public_path__ + "static/konfor-sm-207c15dcb0523866740eef0fe373be0b.jpg";